import React, { useEffect, useState, useRef } from "react";
import GroupTitle from "./GroupTitle";
import { CircleLoader } from "../Elements";
import { getCustomerBalance, getCustomerBalanceMemo } from "../../../common/helpers/paymentHelpers";
import { formatCurrency, formatDateOnFrontWithoutTime } from "../../../lib/helpers";
import { getCurrencySymbolByCurrencyId } from "../../../common/helpers/getCurrencySymbolByCurrencyId";
import { useSelector } from "react-redux";
import { RootStateType } from "../../../store/RootState";

type Props = {
    customerId: number,
    description?: string,
    isPaymentLink: boolean,
    invoiceNumber?: string,
    gibInvoiceNumber?: string,
    invoicePaymentDate?: any,
    invoiceDate?: any,
    currencyId: number
}

const balanceCache: Record<number, string> = {};

const CustomerAmountInformationArea = React.memo((props: Props) => {
    const { customerId, description, isPaymentLink, gibInvoiceNumber,
         invoiceNumber, invoicePaymentDate, invoiceDate, currencyId } = props;
    const currencyList = useSelector((state: RootStateType) => state.firmCurrencyList.currencyList);
    
    const [customerBalance, setCustomerBalance] = useState(() => 
        balanceCache[customerId] || ""
    );
    const [customerBalanceError, setCustomerBalanceError] = useState("");
    const [customerBalanceLoading, setCustomerBalanceLoading] = useState(false);
    
    const isBalanceLoaded = useRef(false);

    const selectCustomerBalance = async () => {
        setCustomerBalanceLoading(true);
        setCustomerBalanceError("");

        const balance = await getCustomerBalance(customerId);
        if (balance.isSuccess) {
            const formattedBalance = formatCurrency(balance.data);
            setCustomerBalance(formattedBalance);
            // Global cache'e kaydet
            balanceCache[customerId] = formattedBalance;
        } else {
            setCustomerBalanceError(balance.data);
        }

        setCustomerBalanceLoading(false);
    }

    const selectCustomerBalanceNotLoading = async () => {
        
        if (balanceCache[customerId]) {
            setCustomerBalance(balanceCache[customerId]);
            return;
        }

        setCustomerBalanceLoading(true);
        setCustomerBalanceError("");
        const balance = await getCustomerBalanceMemo(customerId);
        if (balance.isSuccess) {
            const formattedBalance = formatCurrency(balance.data);
            setCustomerBalance(formattedBalance);
            balanceCache[customerId] = formattedBalance;
        } else {
            setCustomerBalanceError(balance.data);
        }
        setCustomerBalanceLoading(false);
    }

    useEffect(() => {
        if (customerId > 0 && !isBalanceLoaded.current) {
            selectCustomerBalanceNotLoading();
            isBalanceLoaded.current = true;
        }
    }, []);

    let title = "Borç Bakiyesi";
    if (isPaymentLink && invoiceNumber) {
        title = "Fatura Bilgileri"
    }

    return (
        <div className="w-full px-6 py-4 bg-white shadow-custom rounded-lg  mt-6">
            <GroupTitle title={title} lineclass="!border-primary" />
            {customerBalanceLoading ? (
                <div className="text-right text-black text-2xl font-bold  mt-4">
                    <CircleLoader loadingMessage="Borç bakiyesi yükleniyor..." />

                </div>
            ) : (customerBalanceError?.length > 0) ? (
                <div className="text-danger  text-sm text-center">
                    {customerBalanceError}
                </div>
            ) : (
                <div className="text-right text-black text-2xl font-bold  mt-4">{getCurrencySymbolByCurrencyId(currencyList, props.currencyId)} {customerBalance || "0.00"}</div>
            )}
                {invoiceDate && (
                <div className="flex justify-between my-2">
                    <div className="text-zinc-400 text-xs font-bold" >
                        Fatura Tarihi:
                    </div>
                    <div className="text-zinc-800 text-xs font-normal" >
                        {formatDateOnFrontWithoutTime(invoiceDate)}
                    </div>
                </div>
            )}
            {invoicePaymentDate && (
                <div className="flex justify-between my-2">
                    <div className="text-zinc-400 text-xs font-bold" >
                        Vade Tarihi:
                    </div>
                    <div className="text-zinc-800 text-xs font-normal" >
                        {formatDateOnFrontWithoutTime(invoicePaymentDate)}
                    </div>
                </div>
            )}
            {/* {invoiceNumber && (

                <div className="flex justify-between my-2">
                    <div className="text-zinc-400 text-xs font-bold" >
                        Fatura Numarası:
                    </div>
                    <div className="text-zinc-800 text-xs font-normal" >
                        {invoiceNumber}
                    </div>
                </div>
            )} */}
            {gibInvoiceNumber && (
                <div className="flex justify-between my-2">
                    <div className="text-zinc-400 text-xs font-bold" >
                        Fatura Numarası:
                    </div>
                    <div className="text-zinc-800 text-xs font-normal" >
                        {gibInvoiceNumber}
                    </div>
                </div>
            )}

            {description && (
                <div className="text-center text-zinc-500 text-sm font-normal mt-3 break-words">
                    {description}
                </div>
            )}
        </div>
    );
});

export default CustomerAmountInformationArea;